export const DocUpgradeIllustration = ({ className }: TProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="192"
    height="108"
    fill="none"
    className={className}
    viewBox="0 0 257 144"
  >
    <g filter="url(#a)">
      <rect
        width="12.073"
        height="4.474"
        x="186.336"
        y="7.516"
        fill="#71C9C4"
        rx="2.237"
        transform="rotate(90 186.336 7.516)"
      />
      <rect
        width="12.076"
        height="4.473"
        fill="#71C9C4"
        rx="2.236"
        transform="rotate(120.024 102.118 68.167) skewX(.048)"
      />
      <rect
        width="12.076"
        height="4.473"
        fill="#71C9C4"
        rx="2.236"
        transform="rotate(59.976 69.846 144.306) skewX(-.048)"
      />
      <rect
        width="12.073"
        height="4.474"
        fill="#71C9C4"
        rx="2.237"
        transform="matrix(0 -1 -1 0 186.336 134.695)"
      />
      <rect
        width="12.076"
        height="4.473"
        fill="#71C9C4"
        rx="2.236"
        transform="matrix(-.50036 -.86582 -.86623 .49964 212.234 128.352)"
      />
      <rect
        width="12.076"
        height="4.473"
        fill="#71C9C4"
        rx="2.236"
        transform="matrix(.50036 -.86582 -.86623 -.49964 159.84 130.584)"
      />
      <path
        fill="#fff"
        d="M30.902 52.97c0-2.464 1.976-4.462 4.414-4.462h35.308c2.437 0 4.413 1.998 4.413 4.462v37.372c0 2.465-1.976 4.463-4.413 4.463H35.316c-2.438 0-4.414-1.998-4.414-4.463V52.97Z"
      />
      <path
        fill="#526476"
        d="M35.316 54.644c0-.925.74-1.674 1.655-1.674h24.274c.914 0 1.655.75 1.655 1.674 0 .924-.741 1.673-1.655 1.673H36.971c-.914 0-1.655-.75-1.655-1.673ZM35.316 64.126a1.11 1.11 0 0 1 1.103-1.116h15.6c.61 0 1.104.5 1.104 1.116a1.11 1.11 0 0 1-1.104 1.116h-15.6c-.61 0-1.103-.5-1.103-1.116ZM61.797 64.126A1.11 1.11 0 0 1 62.9 63.01h6.62c.61 0 1.104.5 1.104 1.116a1.11 1.11 0 0 1-1.104 1.116H62.9c-.61 0-1.103-.5-1.103-1.116Z"
      />
      <path
        fill="#97A2AD"
        d="M35.316 72.772c0-.462.37-.837.827-.837h16.152c.457 0 .828.375.828.837 0 .462-.37.837-.828.837H36.143a.832.832 0 0 1-.827-.837Z"
      />
      <path
        fill="#526476"
        d="M65.107 72.772c0-.462.37-.837.827-.837h3.862c.457 0 .828.375.828.837 0 .462-.37.837-.828.837h-3.862a.832.832 0 0 1-.827-.837Z"
      />
      <path
        fill="#97A2AD"
        d="M35.316 78.35c0-.462.37-.837.827-.837h16.152c.457 0 .828.375.828.837 0 .462-.37.836-.828.836H36.143a.832.832 0 0 1-.827-.836Z"
      />
      <path
        fill="#526476"
        d="M65.107 78.35c0-.462.37-.837.827-.837h3.862c.457 0 .828.375.828.837 0 .462-.37.836-.828.836h-3.862a.832.832 0 0 1-.827-.836Z"
      />
      <path
        fill="#97A2AD"
        d="M35.316 83.928c0-.462.37-.837.827-.837h16.152c.457 0 .828.375.828.837 0 .462-.37.836-.828.836H36.143a.832.832 0 0 1-.827-.836Z"
      />
      <path
        fill="#526476"
        d="M65.107 83.928c0-.462.37-.837.827-.837h3.862c.457 0 .828.375.828.837 0 .462-.37.836-.828.836h-3.862a.832.832 0 0 1-.827-.836Z"
      />
      <path
        fill="#97A2AD"
        d="M35.316 89.506c0-.463.37-.837.827-.837h16.152c.457 0 .828.374.828.837 0 .462-.37.836-.828.836H36.143a.832.832 0 0 1-.827-.836Z"
      />
      <path
        fill="#526476"
        d="M65.107 89.506c0-.463.37-.837.827-.837h3.862c.457 0 .828.374.828.837 0 .462-.37.836-.828.836h-3.862a.832.832 0 0 1-.827-.836Z"
      />
      <path
        fill="#fff"
        d="M151 44.072c0-3.638 2.964-6.588 6.62-6.588h52.962c3.656 0 6.62 2.95 6.62 6.588V99.24c0 3.638-2.964 6.587-6.62 6.587H157.62c-3.656 0-6.62-2.949-6.62-6.587V44.072Z"
      />
      <path
        fill="#526476"
        d="M157.62 46.542a2.477 2.477 0 0 1 2.483-2.47h36.411a2.476 2.476 0 0 1 2.482 2.47 2.476 2.476 0 0 1-2.482 2.47h-36.411a2.477 2.477 0 0 1-2.483-2.47ZM157.62 60.54c0-.91.741-1.647 1.655-1.647h23.4c.915 0 1.656.737 1.656 1.647s-.741 1.647-1.656 1.647h-23.4a1.65 1.65 0 0 1-1.655-1.647ZM197.341 60.54c0-.91.741-1.647 1.655-1.647h9.931a1.65 1.65 0 0 1 1.655 1.647 1.65 1.65 0 0 1-1.655 1.647h-9.931a1.65 1.65 0 0 1-1.655-1.647Z"
      />
      <path
        fill="#97A2AD"
        d="M157.62 73.303c0-.682.556-1.236 1.241-1.236h24.228c.686 0 1.242.554 1.242 1.236 0 .682-.556 1.235-1.242 1.235h-24.228a1.238 1.238 0 0 1-1.241-1.235Z"
      />
      <path
        fill="#526476"
        d="M202.307 73.303c0-.682.555-1.236 1.241-1.236h5.793c.685 0 1.241.554 1.241 1.236 0 .682-.556 1.235-1.241 1.235h-5.793a1.238 1.238 0 0 1-1.241-1.235Z"
      />
      <path
        fill="#97A2AD"
        d="M157.62 81.537c0-.682.556-1.235 1.241-1.235h24.228c.686 0 1.242.553 1.242 1.235s-.556 1.235-1.242 1.235h-24.228a1.238 1.238 0 0 1-1.241-1.235Z"
      />
      <path
        fill="#526476"
        d="M202.307 81.537c0-.682.555-1.235 1.241-1.235h5.793c.685 0 1.241.553 1.241 1.235s-.556 1.235-1.241 1.235h-5.793a1.238 1.238 0 0 1-1.241-1.235Z"
      />
      <path
        fill="#97A2AD"
        d="M157.62 89.77c0-.681.556-1.234 1.241-1.234h24.228c.686 0 1.242.553 1.242 1.235s-.556 1.235-1.242 1.235h-24.228a1.238 1.238 0 0 1-1.241-1.235Z"
      />
      <path
        fill="#526476"
        d="M202.307 89.77c0-.681.555-1.234 1.241-1.234h5.793c.685 0 1.241.553 1.241 1.235s-.556 1.235-1.241 1.235h-5.793a1.238 1.238 0 0 1-1.241-1.235Z"
      />
      <path
        fill="#97A2AD"
        d="M157.62 98.005c0-.682.556-1.235 1.241-1.235h24.228c.686 0 1.242.553 1.242 1.235s-.556 1.235-1.242 1.235h-24.228a1.238 1.238 0 0 1-1.241-1.235Z"
      />
      <path
        fill="#526476"
        d="M202.307 98.005c0-.682.555-1.235 1.241-1.235h5.793c.685 0 1.241.553 1.241 1.235s-.556 1.235-1.241 1.235h-5.793a1.238 1.238 0 0 1-1.241-1.235Z"
      />
      <path
        fill="#71C9C4"
        fillRule="evenodd"
        d="m126.015 59.965 10.533 10.522a1.653 1.653 0 0 1 0 2.339l-10.533 10.522a1.655 1.655 0 0 1-2.34 0 1.651 1.651 0 0 1 0-2.338l7.707-7.7H90.847a1.654 1.654 0 1 1 0-3.307h40.535l-7.707-7.7a1.651 1.651 0 0 1 0-2.338 1.655 1.655 0 0 1 2.34 0Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="a"
        width="282.188"
        height="169.504"
        x="-13.094"
        y="-5.096"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          radius="4"
          result="effect1_dropShadow_2185_1412"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2185_1412"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_2185_1412"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export type TProps = {
  width?: number;
  height?: number;
  className?: string;
};
